import { render, staticRenderFns } from "./contactsTpl.vue?vue&type=template&id=6b52ec26&"
import script from "./contactsTpl.vue?vue&type=script&lang=js&"
export * from "./contactsTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports